﻿<umphome-list [users]="users"
              [totalResultsCount]="count"
              (userOpened)="dialogRef.close()">
</umphome-list>

<div class="stickypanel" style="padding:20px!important">
    <button mat-raised-button (click)="backButtonHandler()" type="submit" class="btn button-fix button-color-fix-red">
        <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
        Back
    </button>
</div>